import React from 'react';

const Experts = () => {
  return (
    <section className="section bg-light-200 faq-sec">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="tourism-text-info">
                        <div className="text-header">
                            <h2>Giải pháp đáng tin cậy cho dịch vụ <span className="text-primary"> <img src="assets/img/tours/tour-img.jpg" alt="img"/> Du lịch</span> của bạn</h2>
                        </div>
                        <div className="card border-secondary shadow-none bg-secondary-transparent">
                            <div className="card-body d-flex align-items-center">
                                <span className="avatar bg-secondary rounded-circle flex-shrink-0">
                                    <i className="isax isax-lock-1 text-gray-9 fs-20"></i>
                                </span>
                                <div className="ms-3">
                                    <h5 className="mb-1">Gói VIP</h5>
                                    <p>Bao gồm chỗ ngồi cao cấp, gặp gỡ nghệ sĩ, tham quan hậu trường.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card border-purple shadow-none bg-purple-transparent">
                            <div className="card-body d-flex align-items-center">
                                <span className="avatar bg-purple rounded-circle flex-shrink-0">
                                    <i className="isax isax-receipt-add fs-20"></i>
                                </span>
                                <div className="ms-3">
                                    <h5 className="mb-1">Gói du lịch</h5>
                                    <p>Trọn gói bao gồm vé tham quan, chỗ ở.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card border-teal shadow-none bg-teal-transparent">
                            <div className="card-body d-flex align-items-center">
                                <span className="avatar bg-teal rounded-circle flex-shrink-0">
                                    <i className="isax isax-location-tick fs-20"></i>
                                </span>
                                <div className="ms-3">
                                    <h5 className="mb-1">Đảm bảo giá tốt nhất</h5>
                                    <p>Như các buổi diễn tập riêng, quyền truy cập soundcheck.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="faq-cards-six">
                        <div className="section-header-six mb-4">
                            <span className="badge badge-soft-primary rounded-pill mb-1">Nhà cung cấp phổ biến nhất</span>
                            <h2>Hãy thử trải nghiệm lưu trú thư giãn.</h2>
                        </div>
                        <div className="accordion accordion-flush" id="accordionFaq">
                            <div className="accordion-item show wow fadeInUp" data-wow-delay="0.2s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq-collapseOne" aria-expanded="false" aria-controls="faq-collapseOne">
                                        Những loại tour nào bạn cung cấp?
                                    </button>
                                </h2>
                                <div id="faq-collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p className="mb-0">Chúng tôi cung cấp nhiều loại tour khác nhau, bao gồm văn hóa, phiêu lưu, sang trọng và hành trình tùy chỉnh.</p>
                                        <p>Điểm đến phổ biến bao gồm Châu Âu, Châu Phi (ví dụ: Morocco).</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-collapsetwo" aria-expanded="false" aria-controls="faq-collapsetwo">
                                        Tour có thể tùy chỉnh không?
                                    </button>
                                </h2>
                                <div id="faq-collapsetwo" className="accordion-collapse collapse" data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Chúng tôi cung cấp nhiều loại tour khác nhau, bao gồm văn hóa, phiêu lưu, sang trọng và hành trình tùy chỉnh.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-collapsthree" aria-expanded="false" aria-controls="faq-collapsthree">
                                        Các biện pháp an toàn nào được áp dụng?
                                    </button>
                                </h2>
                                <div id="faq-collapsthree" className="accordion-collapse collapse" data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Chúng tôi cung cấp nhiều loại tour khác nhau, bao gồm văn hóa, phiêu lưu, sang trọng và hành trình tùy chỉnh.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.8s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-collapsefour" aria-expanded="false" aria-controls="faq-collapsefour">
                                        Tôi nên đặt tour trước bao lâu?
                                    </button>
                                </h2>
                                <div id="faq-collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Chúng tôi cung cấp nhiều loại tour khác nhau, bao gồm văn hóa, phiêu lưu, sang trọng và hành trình tùy chỉnh.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item wow fadeInUp" data-wow-delay="1.0s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-collapsefive" aria-expanded="false" aria-controls="faq-collapsefive">
                                        Chính sách hủy tour của bạn là gì?
                                    </button>
                                </h2>
                                <div id="faq-collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Chúng tôi cung cấp nhiều loại tour khác nhau, bao gồm văn hóa, phiêu lưu, sang trọng và hành trình tùy chỉnh.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Experts;
